import React, { useState } from "react";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/aible/Dialog/Dialog";
import { Button } from "@/aible";
import { useDispatch } from "@/types/store";
import { createFocusedDataset, getLinkedComparisonProjects } from "@/containers/Next/NextReducer";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import * as globalReducer from "@/containers/App/reducer";
import { Alert } from "react-bootstrap";
export const MIN_EVALUATOR_ROWS = 50;
const DashboardFocusModal = ({ id, open, chart, handleClose }) => {
    const dispatch = useDispatch();
    const isCreating = useSelector((state) => globalReducer.getIsCreatingFocusedDataset(state));
    const [isCreationStarting, updateIsCreationStarting] = useState(false);
    const linkedComparisonProjects = useSelector((state) => getLinkedComparisonProjects(state, id)) ?? {};
    let title = chart?.title;
    if (Object.keys(linkedComparisonProjects ?? {}).length > 0 && linkedComparisonProjects["@_Original_@"] != id) {
        const foundPair = Object.entries(linkedComparisonProjects).find(([key, nextId]) => nextId == id);
        if (foundPair !== undefined) {
            title = `${foundPair[0]} and ${title}`;
        }
    }
    if (!chart) {
        return null;
    }
    const handleCreateNewDataset = async () => {
        try {
            updateIsCreationStarting(true);
            setTimeout(() => {
                handleClose();
                updateIsCreationStarting(false);
            }, 2000);
            await dispatch(createFocusedDataset(chart));
        }
        catch (error) {
            console.error("Error creating focused dataset:", error);
            toast(React.createElement("div", null, "There was an error creating your focused project. Please contact aible support if this issue persists."), {
                type: toast.TYPE.ERROR,
                position: toast.POSITION.TOP_CENTER,
                autoClose: 7500
            });
            updateIsCreationStarting(false);
        }
    };
    const onOpenChange = () => {
        if (!isCreating) {
            handleClose();
        }
    };
    const shouldShowAlert = chart?.differenceRawData?.previousPursued !== undefined &&
        chart?.differenceRawData?.newPursued !== undefined &&
        chart.differenceRawData.previousPursued + chart.differenceRawData.newPursued < MIN_EVALUATOR_ROWS;
    return (React.createElement(Dialog, { open: open, onOpenChange: () => onOpenChange() },
        React.createElement(DialogContent, { showCloseButton: isCreating },
            React.createElement(DialogHeader, null,
                React.createElement(DialogTitle, null, "Evaluate What's Changed?")),
            React.createElement("div", null,
                "Would you like to create an analysis focused on what changed when the ",
                React.createElement("strong", null, title),
                "?",
                React.createElement("br", null),
                React.createElement("br", null),
                "Your current report ",
                React.createElement("strong", null, "will not be lost"),
                ". For larger datasets, this process may take a few minutes."),
            shouldShowAlert && (React.createElement(Alert, { bsStyle: "warning" },
                React.createElement("strong", null, "Caution: "),
                "This group contains less than ",
                MIN_EVALUATOR_ROWS,
                " rows. There may be no insights available")),
            React.createElement(DialogFooter, null,
                React.createElement(Button, { type: "primary", onClick: () => handleCreateNewDataset(), disabled: isCreating || isCreationStarting, isLoading: isCreating || isCreationStarting }, "Create Focused Analysis"),
                React.createElement(Button, { type: "secondary", onClick: () => onOpenChange(), disabled: isCreating }, "Cancel")))));
};
export default DashboardFocusModal;
